module.exports = __webpack_public_path__ + "static/media/withdraw_funds.bb92bed6.svg";